module.exports = __webpack_public_path__ + "static/media/kipfilet.75230eaf.jpg";